import React, { useState, useEffect } from 'react'
import { resetPasswordStyles } from './style'
import { Box, TextField, Grid, Button, InputAdornment, IconButton } from '@material-ui/core'
import { useFormik } from 'formik'
import { connect } from 'react-redux'
import _ from 'lodash'
import { userSignUp } from '../../AppRedux/actions/Auth'
import * as yup from 'yup'
import { useLocation } from 'react-router-dom'
import DisplayMessage from '../../Components/DisplayMessage'
import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES, COMMON } from '../../utils/constants'
import * as MESSAGETYPES from '../../utils/messageTypes'
import { AppButton, Loader } from '../../Components'
import { Visibility, VisibilityOff } from '@material-ui/icons'

const validationSchema = yup.object({
  email: yup
    .string('Enter email')
    .email('Enter valid email')
    .required('Email is required'),
  password: yup
    .string('Enter password')
    .required('Please Enter your password')
    .min(8, 'Password should be of minimum 8 characters length')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Must contain at least 8 Characters, One Uppercase, One Lowercase, One Number and one of the following special case characters @, $, !, %, *, ?, &"
    ),
  confirm_password: yup
    .string('Confirm password')
    .required('Passwords not matching')
    .oneOf([yup.ref('password'), null], 'Passwords not matching')
})

function ResetPassword(props) {
  const classes = resetPasswordStyles()
  const search = useLocation().search
  const email = new URLSearchParams(search).get('email')
  const token = new URLSearchParams(search).get('token')
  const reset = new URLSearchParams(search).get('passwdReset')
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [loading, setLoading] = useState(false)
  const [validToken, setValidToken] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const formik = useFormik({
    initialValues: {
      email: email,
      password: '',
      confirm_password: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      service
        .post(
          Urls.getApiUrl(
            `admin/signup/passwordSubmit`,
            MICROSERVICES.SESSIONMANAGER,
          ),
          {
            email: email,
            password: values.password,
            matching_password: values.confirm_password,
            token: token
          },
        )
        .then((verifiedData) => {
          setLoading(false)
          setOpen(true)
          setMessage(verifiedData.data.data)
          setMessageType(MESSAGETYPES.SUCCESS)
          setTimeout(() => {
            props.history.push('/signin')
          }, 3000)
        })
        .catch((error) => {
          setLoading(false)
          setOpen(true)
          setMessage(_.get(error, 'data.error.displayMessage', 'Failed to set password'))
          setMessageType(MESSAGETYPES.ERROR)
        })
    },
  })

  useEffect(() => {
    if (token && email) {
      service
        .post(
          Urls.getApiUrl(
            `admin/signup/verifyToken`,
            MICROSERVICES.SESSIONMANAGER,
          ),
          {
            email: email,
            token: token,
          },
        )
        .then((verifiedData) => {
          setValidToken(true)
        })
        .catch((error) => {
          setOpen(true)
          setMessage(
            _.get(
              error,
              'data.error.displayMessage',
              'Something went wrong',
            ),
          )
          setMessageType(MESSAGETYPES.ERROR)
        })
    }
  }, [email, token])

  const handleClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      <div className={classes.ResetPasswordDiv}>
        <DisplayMessage
          open={open}
          message={message}
          messageType={messageType}
          handleClose={handleClose}
        />
        <Loader loading={loading} />
        <Box className={classes.ResetPasswordBox}>
          <Box className={classes.ResetPasswordTextBox}>
            <p>{reset === 'true' ? 'Reset' : 'Set'} Password</p>
          </Box>
          <hr />
          <Box className={classes.container}>
            <p className={classes.resetText}>Please enter your new password.</p>
            <form onSubmit={formik.handleSubmit}>
              <Box mb={4}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="email"
                      name="email"
                      label="Email"
                      value={email}
                      disabled
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="password"
                      name="password"
                      type="password"
                      label="Enter new password"
                      disabled={!validToken}
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="confirm-password"
                      name="confirm_password"
                      label="Confirm new password"
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            disabled={!validToken}
                            onClick={() => setShowPassword((show) => !show)}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>,
                      }}
                      disabled={!validToken}
                      value={formik.values.confirm_password}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.confirm_password &&
                        Boolean(formik.errors.confirm_password)
                      }
                      helperText={
                        formik.touched.confirm_password &&
                        formik.errors.confirm_password
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
              <AppButton
                type="submit"
                disabled={!validToken}
                text="Submit"
              />
            </form>
          </Box>
        </Box>
      </div>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { message, loading } = auth
  return { message, loading }
}

const mapDispatchToProps = (dispatch) => ({
  userSignUp: (payload) => dispatch(userSignUp(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
